import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  // Three columns keep the zoom / pager controls centered regardless of the
  // width of the right-aligned actions.
  toolbar: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    gap: 12,
    marginBottom: 12
  },
  toolbarControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Zoom + pager do not fit one row on a phone; the pager wraps under.
    flexWrap: 'wrap',
    gap: 12
  },
  toolbarActions: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  toolbarButton: {
    border: '1px solid #E8ECEE',
    width: 32,
    height: 32,
    padding: 0
  },
  zoomLabel: {
    minWidth: 48,
    textAlign: 'center'
  },
  divider: {
    width: 1,
    alignSelf: 'stretch',
    background: '#E8ECEE'
  },
  // Scrollable canvas area — the rendered page can exceed it when zoomed in.
  // Flex + auto margins on the child center the content (and the "Loading
  // PDF..." state) both ways without breaking scrolling when zoomed in.
  scrollArea: {
    flex: 1,
    display: 'flex',
    overflow: 'auto',
    borderRadius: 12,
    background: '#EEF0F2',
    padding: 16
  },
  // Shrinks to the page size so a zoomed-out page stays centered while a
  // zoomed-in one scrolls in both directions.
  doc: {
    width: 'fit-content',
    margin: 'auto',
    '& .react-pdf__Page': {
      background: 'transparent'
    },
    '& canvas': {
      display: 'block',
      borderRadius: 8
    },
    '& .react-pdf__Page__textContent, & .react-pdf__Page__annotations': {
      display: 'none'
    }
  }
});
